module.exports = __webpack_public_path__ + "static/media/live.40119a54.svg";